import { useI18N } from '@vivino/js-web-common';
import PropTypes from 'prop-types';
import React from 'react';
import IndicatorBar from 'vivino-ui/atoms/IndicatorBar';

import styles from './tasteStructure.scss';

const TRANSLATION_PATH = 'components.shared.taste_structure';

const TRANSLATIONS = {
  light: `${TRANSLATION_PATH}.light`,
  bold: `${TRANSLATION_PATH}.bold`,
  smooth: `${TRANSLATION_PATH}.smooth`,
  tannic: `${TRANSLATION_PATH}.tannic`,
  dry: `${TRANSLATION_PATH}.dry`,
  sweet: `${TRANSLATION_PATH}.sweet`,
  soft: `${TRANSLATION_PATH}.soft`,
  acidic: `${TRANSLATION_PATH}.acidic`,
  gentle: `${TRANSLATION_PATH}.gentle`,
  fizzy: `${TRANSLATION_PATH}.fizzy`,
};

const getTranslatedCharacteristics = (t) => [
  {
    key: 'intensity',
    low: t(TRANSLATIONS.light),
    high: t(TRANSLATIONS.bold),
  },
  {
    key: 'tannin',
    low: t(TRANSLATIONS.smooth),
    high: t(TRANSLATIONS.tannic),
  },
  {
    key: 'sweetness',
    low: t(TRANSLATIONS.dry),
    high: t(TRANSLATIONS.sweet),
  },
  {
    key: 'acidity',
    low: t(TRANSLATIONS.soft),
    high: t(TRANSLATIONS.acidic),
  },
  {
    key: 'fizziness',
    low: t(TRANSLATIONS.gentle),
    high: t(TRANSLATIONS.fizzy),
  },
];

const MIN_TASTE_VALUE = 1;
const MAX_TASTE_VALUE = 5;

const TasteStructure = ({ structure }) => {
  const { t } = useI18N();
  return (
    <table className={styles.tasteStructure}>
      <tbody>
        {getTranslatedCharacteristics(t).map((characteristic) => {
          if (!structure[characteristic.key]) {
            return null;
          }

          return (
            <tr key={characteristic.key} className={styles.tasteCharacteristic}>
              <td>
                <div className={styles.property}>{characteristic.low}</div>
              </td>
              <td className={styles.progressBar}>
                <IndicatorBar
                  value={structure[characteristic.key]}
                  minValue={MIN_TASTE_VALUE}
                  maxValue={MAX_TASTE_VALUE}
                  className={styles.progressBar}
                />
              </td>
              <td>
                <div className={styles.property}>{characteristic.high}</div>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

TasteStructure.propTypes = {
  structure: PropTypes.object,
};

export default TasteStructure;
